"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CirclePdf.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CirclePdf = function CirclePdf(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 515 515"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Circle PDF Icon"), _react2.default.createElement("g", {
    className: "pdf",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("g", {
    className: "icon",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M252.84 247.23a261.11 261.11 0 0 1-12.75 28.41c-2.49 4.78-4.92 9.29-7.26 13.57a264.54 264.54 0 0 1 44.3-12.62q-1.74-1.35-3.29-2.69a93.51 93.51 0 0 1-21-26.67zm1.16-33.97c2.3-4.2 4.16-9.9 4-18s-2.07-16.75-5.43-16.75c-1.54 0-1.4 12.25-1.4 12.26-.03 6.43.88 16.23 2.83 22.49zm92.59-23.41l-35.38-36.08a21 21 0 0 0-2.8-2.35v41.29h40.48a21.33 21.33 0 0 0-2.3-2.86zM186.47 333.86c5.18-2.37 12.95-9.94 24.61-28.94-1.57 1.54-3.3 3.19-4 3.77-11.17 9.31-18.7 19.85-20.61 25.17zm147.87-51.08c-6-1.54-7.86-1.54-14-1.54-3.35 0-7.09.16-11.17.47 10.61 4.64 18.18 7.5 24.3 7.5 1.87 0 4.87-.34 5.87-1 1.02-.62 1-3.88-5-5.43z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M355.6 209h-63v-64.3a21.16 21.16 0 0 0-4-.43H169.72a4.06 4.06 0 0 0-4 4v218.5a4.06 4.06 0 0 0 4 4H352a4.06 4.06 0 0 0 4-4V213a22.44 22.44 0 0 0-.4-4zM343 294.32a8.82 8.82 0 0 1-5.15 3.59 20.25 20.25 0 0 1-5.18.58c-11.39 0-29.44-5.86-44.12-14.3A384.81 384.81 0 0 0 228 298.88C211.34 328.67 199.2 342 188.74 342a12.32 12.32 0 0 1-5.66-1.39l-4.16-2.14c-2.61-1.53-3-4.82-2.48-7.39 1.6-8.06 11.32-18.21 26-27.16 1.73-1.07 9.11-5 9.42-5.22l4.3-2.32c4.17-7.28 8.76-15.88 13.83-26l.63-1.25c4.81-9.63 10.27-20.55 14.63-31.39l1.56-3.87c-6.09-23.73-9.44-42.05-6.19-54.3 1.07-3.91 5.15-6.52 10.15-6.52h.07l2.63.09c4.49-.2 7.35 3.44 8.81 6.88l.47 1.22a12.34 12.34 0 0 1 .7 3c1.42 10.52-4 41.64-4 41.64-.25 1.16-.53 2.29-.85 3.59 4.95 13.86 12.9 26.47 22.43 35.55a68 68 0 0 0 12.43 8.76 181.09 181.09 0 0 1 26.79-2c11.4.15 18.9 2 22.28 5.35a8.64 8.64 0 0 1 2.5 4.37c.65 4.74.2 9.42-2.03 12.82z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    },
    __self: undefined
  })), _react2.default.createElement("path", {
    d: "M257.5 0C115.29 0 0 115.29 0 257.5S115.29 515 257.5 515 515 399.71 515 257.5 399.71 0 257.5 0zm114.3 366.77A20.08 20.08 0 0 1 352 387H169.72a20.08 20.08 0 0 1-19.81-20.23V148.22A20.08 20.08 0 0 1 169.72 128H288.6c10.89 0 26.11 6.43 33.82 14.3l35.38 36.12c7.71 7.87 14 23.41 14 34.53v153.82z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = CirclePdf;